// extracted by mini-css-extract-plugin
export default {"header":"header__OVZyn","nav":"nav__ikPuw","active":"active__r+Z6z"};